import axios from "axios";
import { CategoryItem } from "../types/category.types";
import PKSOFT_URLS from "../utilities/Pk_api_Urls";

const categoryCache = new Map<string, CategoryItem[]>();
const categoryRequests = new Map<string, Promise<CategoryItem[]>>();

const getResponseArray = (payload: unknown): unknown[] => {
  if (Array.isArray(payload)) return payload;
  if (payload && typeof payload === "object" && "data" in payload) {
    const data = (payload as { data?: unknown }).data;
    return Array.isArray(data) ? data : [];
  }
  return [];
};

const normalizeCategories = (payload: unknown): CategoryItem[] =>
  getResponseArray(payload).filter(
    (item): item is CategoryItem => item !== null && typeof item === "object",
  );

export const fetchCategories = async (
  url = PKSOFT_URLS.CUSTOMER.CATEGORY,
): Promise<CategoryItem[]> => {
  const cachedCategories = categoryCache.get(url);
  if (cachedCategories) return cachedCategories;

  const existingRequest = categoryRequests.get(url);
  if (existingRequest) return existingRequest;

  const request = axios
    .get(url)
    .then((response) => {
      const categories = normalizeCategories(response.data);
      categoryCache.set(url, categories);
      return categories;
    })
    .finally(() => {
      categoryRequests.delete(url);
    });

  categoryRequests.set(url, request);
  return request;
};

export const clearCategoryCache = (url = PKSOFT_URLS.CUSTOMER.CATEGORY) => {
  categoryCache.delete(url);
  categoryRequests.delete(url);
};
